export const trimFirstLine = (html) => {
    return html.replace('<!---->', '');
};
